import axiosInstance from "../../axios/axiosInstance";
import { CREATE_TEMPLATE, DELETE_TEMPLATE, EDIT_TEMPLATE, FOOTER_LISTING_PAGINATE, HEADER_LISTING_PAGINATE, STATUS_UPDATE_TEMPLATE, SUBMIT_IMAGE_TEMPLATE, TEMPLATE_LISTING, TEMPLATE_LISTING_PAGINATE, TEMPLATE_SINGLE_LISTING } from "../../constants";

export const createTemplate = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_TEMPLATE, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const editTemplate = (id, values) => onResponse => {
    try {
        axiosInstance.put(`${EDIT_TEMPLATE}/${id}`, values)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        console.error('Error in editTemplate:', error);
    }
};


export const getTemplateListing = ({ skip, limit, search }) => onResponse => {
    const BASE_URL = `${TEMPLATE_LISTING}?skip=${skip}&limit=${limit}&search=${search}`;
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) {
        console.error("Fetching error:", error);
        onResponse(error);
    }
};

export const getHeaderListingPaginate = (props) => onResponse => {
    try {

        let BASE_URL = HEADER_LISTING_PAGINATE + '?';
        if (props?.page) {
            BASE_URL += 'page=' + props?.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'pageSize=' + props?.limit + '&'
        }

        BASE_URL += 'search=' + props?.search ?? '' + '&'

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getFooterListingPaginate = (props) => onResponse => {
    try {

        let BASE_URL = FOOTER_LISTING_PAGINATE + '?';
        if (props?.page) {
            BASE_URL += 'page=' + props?.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'pageSize=' + props?.limit + '&'
        }

        BASE_URL += 'search=' + props?.search ?? '' + '&'

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getTemplateDetails = (id) => (onResponse) => {
    try {
        axiosInstance
            .get(TEMPLATE_SINGLE_LISTING + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) { }
};


export const statusUpdateTemplate = (id) => onResponse => {

    try {
        axiosInstance.put(STATUS_UPDATE_TEMPLATE + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const deleteTemplate = (id) => onResponse => {

    try {
        axiosInstance.delete(DELETE_TEMPLATE + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const submitImageTemplate = (props) => onResponse => {

    try {
        axiosInstance.post(SUBMIT_IMAGE_TEMPLATE, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
